/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid.js.map